import { DefaultState } from 'store/types';

export const POST_LODGING_POLICY_REQUEST = 'POST_LODGING_POLICY_REQUEST';
export const POST_LODGING_POLICY_SUCCESS = 'POST_LODGING_POLICY_SUCCESS';
export const POST_LODGING_POLICY_FAILURE = 'POST_LODGING_POLICY_FAILURE';


export interface LodgingPolicyForm {
  id?: string;
  policyName: string;
  policy: string;
  status: string;
}

export interface PostLodgingPolicyRow {
  id: string;
  policy: string;
}

export interface PostLodgingPolicyData {
  rows: PostLodgingPolicyRow[];
  totalCount: number;
}

export type PostLodgingPolicyState = DefaultState & {
  contents?: PostLodgingPolicyData;
};

interface PostLodgingPolicyRequest {
  type: typeof POST_LODGING_POLICY_REQUEST;
}

interface PostLodgingPolicySuccess {
  type: typeof POST_LODGING_POLICY_SUCCESS;
  contents: PostLodgingPolicyData;
}

interface PostLodgingPolicyFailure {
  type: typeof POST_LODGING_POLICY_FAILURE;
}

export type PostLodgingPolicyActionTypes = PostLodgingPolicyRequest | PostLodgingPolicySuccess | PostLodgingPolicyFailure;